module.exports = __webpack_public_path__ + "static/itunes-52c7175650067298580d51ad3ff35db5.svg";